(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hm-home-sales"] && !Shopify.designMode) return;
  try {
    
  const formatBundleMoney = (cents) => 'Rs.' + (cents / 100).toLocaleString('en-PK', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  const activateSetSlide = (carousel, nextIndex) => {
    const slides = Array.from(carousel.querySelectorAll('[data-set-slide]'));
    const index = (nextIndex + slides.length) % slides.length;
    const slide = slides[index];
    carousel.dataset.index = String(index);
    carousel.querySelector('[data-set-track]').style.transform = 'translateX(-' + (index * 100) + '%)';
    slides.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === index));

    const setSection = carousel.closest('.hm-home-sales__set');
    const matId = slide.dataset.matId;
    const napkinId = slide.dataset.napkinId;
    const runnerId = slide.dataset.runnerId;
    const matPrice = Number(slide.dataset.matPrice);
    const napkinPrice = Number(slide.dataset.napkinPrice);
    const runnerPrice = Number(slide.dataset.runnerPrice);

    setSection.querySelectorAll('[data-bundle-option]').forEach((option) => {
      const matQty = Number(option.dataset.matQty);
      const napkinQty = Number(option.dataset.napkinQty);
      const runnerQty = Number(option.dataset.runnerQty);
      const items = [];
      if (matQty) items.push(matId + ':' + matQty);
      if (napkinQty) items.push(napkinId + ':' + napkinQty);
      if (runnerQty) items.push(runnerId + ':' + runnerQty);
      const price = (matPrice * matQty) + (napkinPrice * napkinQty) + (runnerPrice * runnerQty);
      option.dataset.items = items.join(',');
      option.dataset.price = formatBundleMoney(price);
      option.querySelector('small').textContent = option.dataset.price;
    });

    const selectedOption = setSection.querySelector('[data-bundle-option].is-selected');
    const addButton = setSection.querySelector('[data-set-add]');
    addButton.dataset.items = selectedOption.dataset.items;
    addButton.querySelector('strong').textContent = selectedOption.dataset.price;
  };

  document.querySelectorAll('[data-set-carousel]').forEach((carousel) => {
    carousel.dataset.index = '0';
    let timer = window.setInterval(() => {
      activateSetSlide(carousel, Number(carousel.dataset.index) + 1);
    }, 4500);
    carousel.addEventListener('mouseenter', () => window.clearInterval(timer));
    carousel.addEventListener('mouseleave', () => {
      timer = window.setInterval(() => {
        activateSetSlide(carousel, Number(carousel.dataset.index) + 1);
      }, 4500);
    });
  });

  document.addEventListener('click', async (event) => {
    const next = event.target.closest('[data-set-next]');
    const previous = event.target.closest('[data-set-prev]');
    if (next || previous) {
      const carousel = event.target.closest('[data-set-carousel]');
      const direction = next ? 1 : -1;
      activateSetSlide(carousel, Number(carousel.dataset.index) + direction);
      return;
    }
    const option = event.target.closest('[data-bundle-option]');
    if (option) {
      const section = option.closest('.hm-home-sales__set-content');
      section.querySelectorAll('[data-bundle-option]').forEach((choice) => {
        const selected = choice === option;
        choice.classList.toggle('is-selected', selected);
        choice.setAttribute('aria-pressed', String(selected));
      });
      const addButton = section.querySelector('[data-set-add]');
      addButton.dataset.items = option.dataset.items;
      addButton.querySelector('strong').textContent = option.dataset.price;
      return;
    }
    const button = event.target.closest('[data-set-add]');
    if (!button || button.disabled) return;
    const items = button.dataset.items.split(',').filter(Boolean).map((item) => {
      const parts = item.split(':');
      return { id: Number(parts[0]), quantity: Number(parts[1]) };
    });
    if (!items.length) return;
    button.disabled = true;
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!response.ok) throw new Error('cart');
      button.querySelector('span').textContent = button.dataset.addedLabel;
      window.setTimeout(() => {
        window.location.href = window.Shopify.routes.root + 'cart';
      }, 450);
    } catch (error) {
      button.disabled = false;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hm-magic-popup"]) return;
  try {
    
    (() => {
      const dialog = document.querySelector('.hm-magic');
      if (!dialog || typeof dialog.showModal !== 'function') return;

      const storageKey = 'hm-magic-popup-v1';
      const hiddenUntil = Number(localStorage.getItem(storageKey) || 0);
      if (Date.now() < hiddenUntil) return;

      const delay = Number(dialog.dataset.delay || 2800);
      const hideDays = Number(dialog.dataset.hideDays || 14);
      const dataNode = document.getElementById(dialog.id.replace('HmMagicPopup', 'HmMagicData'));
      const rewards = JSON.parse(dataNode.textContent);
      const close = () => {
        localStorage.setItem(storageKey, String(Date.now() + hideDays * 86400000));
        dialog.close();
      };

      window.setTimeout(() => {
        if (!dialog.open) dialog.showModal();
      }, delay);

      dialog.querySelector('[data-hm-close]').addEventListener('click', close);
      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        close();
      });
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) close();
      });

      dialog.querySelector('[data-hm-reveal]').addEventListener('click', () => {
        const pool = ['ten', 'ten', 'shipping', 'shipping', 'postcard'];
        const rewardKey = pool[Math.floor(Math.random() * pool.length)];
        const reward = rewards[rewardKey];
        const claim = dialog.querySelector('[data-hm-claim]');

        dialog.querySelector('[data-hm-intro]').hidden = true;
        dialog.querySelector('[data-hm-result]').hidden = false;
        dialog.querySelector('[data-hm-result-title]').textContent = reward.title;
        dialog.querySelector('[data-hm-result-copy]').textContent = reward.copy;
        dialog.dataset.reward = rewardKey;
        claim.href = reward.url || '#';
        claim.focus();
        localStorage.setItem(storageKey, String(Date.now() + hideDays * 86400000));
      });

      dialog.querySelector('[data-hm-claim]').addEventListener('click', async (event) => {
        if (dialog.dataset.reward !== 'postcard') return;
        event.preventDefault();

        const claim = event.currentTarget;
        const status = dialog.querySelector('[data-hm-status]');
        claim.setAttribute('aria-disabled', 'true');

        try {
          const response = await fetch(`${dialog.dataset.shopUrl}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{
                id: Number(dialog.dataset.postcardVariant),
                quantity: 1,
                properties: { '_Magic reward': 'Complimentary surprise postcard' }
              }]
            })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(`${dialog.dataset.shopUrl}collections/all`);
        } catch (error) {
          status.textContent = rewards.postcard.error;
          claim.removeAttribute('aria-disabled');
        }
      });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hm-paper-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hm-paper-product]').forEach((section) => {
    const price = section.querySelector('[data-product-price]');
    section.querySelectorAll('[data-variant-input]').forEach((input) => {
      input.addEventListener('change', () => {
        if (input.checked && price) price.textContent = input.dataset.price;
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-slideshow"] && !Shopify.designMode) return;
  try {
    
  const initializeReviewSlideshow = (section) => {
    const track = section.querySelector('[data-review-track]');
    const slides = Array.from(section.querySelectorAll('[data-review-slide]'));
    const previous = section.querySelector('[data-review-prev]');
    const next = section.querySelector('[data-review-next]');
    const dotsContainer = section.querySelector('[data-review-dots]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let activeIndex = 0;
    let timer;

    if (!track || slides.length < 2) return;

    const dots = slides.map((slide, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'hm-reviews__dot';
      dot.setAttribute('aria-label', `Show review ${index + 1}`);
      dot.addEventListener('click', () => show(index));
      dotsContainer.appendChild(dot);
      return dot;
    });

    const show = (index) => {
      activeIndex = (index + slides.length) % slides.length;
      track.style.transform = `translateX(-${activeIndex * 100}%)`;
      dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', dotIndex === activeIndex ? 'true' : 'false'));
    };

    const stop = () => window.clearInterval(timer);
    const start = () => {
      stop();
      if (section.dataset.autoplay === 'true' && !reducedMotion) {
        timer = window.setInterval(() => show(activeIndex + 1), Number(section.dataset.interval));
      }
    };

    previous.addEventListener('click', () => {
      show(activeIndex - 1);
      start();
    });
    next.addEventListener('click', () => {
      show(activeIndex + 1);
      start();
    });
    section.addEventListener('mouseenter', stop);
    section.addEventListener('mouseleave', start);
    section.addEventListener('focusin', stop);
    section.addEventListener('focusout', start);
    show(0);
    start();
  };

  document.querySelectorAll('[data-review-slideshow]').forEach(initializeReviewSlideshow);

  } catch(e) { console.error(e); }
})();
})();
